import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileRoutingModule } from './profile-routing.module';
import { ProfileComponent } from './profile.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CoreModule } from '@app/core';
import { SharedModule } from '@app/shared';
import { ProfileService } from './profile.service';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, FlexLayoutModule, ReactiveFormsModule, CoreModule, SharedModule, ProfileRoutingModule],
  declarations: [ProfileComponent],
  providers: [ProfileService]
})
export class ProfileModule {}
